export default "__VITE_ASSET__CxjzSnbj__"